"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.25 2.75C3.85218 2.75 3.47064 2.90804 3.18934 3.18934C2.90804 3.47064 2.75 3.85218 2.75 4.25V15.75C2.75 16.1478 2.90804 16.5294 3.18934 16.8107C3.47064 17.092 3.85218 17.25 4.25 17.25H15.75C16.1478 17.25 16.5294 17.092 16.8107 16.8107C17.092 16.5294 17.25 16.1478 17.25 15.75V11.75C17.25 11.4848 17.3554 11.2304 17.5429 11.0429C17.7304 10.8554 17.9848 10.75 18.25 10.75C18.5152 10.75 18.7696 10.8554 18.9571 11.0429C19.1446 11.2304 19.25 11.4848 19.25 11.75V15.75C19.25 16.6783 18.8813 17.5685 18.2249 18.2249C17.5685 18.8813 16.6783 19.25 15.75 19.25H4.25C3.32174 19.25 2.4315 18.8813 1.77513 18.2249C1.11875 17.5685 0.75 16.6783 0.75 15.75V4.25C0.75 3.32174 1.11875 2.4315 1.77513 1.77513C2.4315 1.11875 3.32174 0.75 4.25 0.75H8.25C8.51522 0.75 8.76957 0.855357 8.95711 1.04289C9.14464 1.23043 9.25 1.48478 9.25 1.75C9.25 2.01522 9.14464 2.26957 8.95711 2.45711C8.76957 2.64464 8.51522 2.75 8.25 2.75H4.25ZM10.75 1.75C10.75 1.48478 10.8554 1.23043 11.0429 1.04289C11.2304 0.855357 11.4848 0.75 11.75 0.75H18.25C18.5152 0.75 18.7696 0.855357 18.9571 1.04289C19.1446 1.23043 19.25 1.48478 19.25 1.75V8.25C19.25 8.51522 19.1446 8.76957 18.9571 8.95711C18.7696 9.14464 18.5152 9.25 18.25 9.25C17.9848 9.25 17.7304 9.14464 17.5429 8.95711C17.3554 8.76957 17.25 8.51522 17.25 8.25V4.164L12.457 8.957C12.3648 9.05251 12.2544 9.12869 12.1324 9.1811C12.0104 9.23351 11.8792 9.2611 11.7464 9.26225C11.6136 9.2634 11.4819 9.2381 11.359 9.18782C11.2361 9.13754 11.1245 9.06329 11.0306 8.96939C10.9367 8.8755 10.8625 8.76385 10.8122 8.64095C10.7619 8.51806 10.7366 8.38638 10.7377 8.2536C10.7389 8.12082 10.7665 7.9896 10.8189 7.8676C10.8713 7.74559 10.9475 7.63525 11.043 7.543L15.836 2.75H11.75C11.4848 2.75 11.2304 2.64464 11.0429 2.45711C10.8554 2.26957 10.75 2.01522 10.75 1.75Z",
    fill: fill
  }));
};

exports["default"] = _default;